<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="500px">
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          <v-icon class="cursor-pointer" title="Update">edit</v-icon>&nbsp;
          <span class="headline" style="font-size:1.3rem!important">Edit Distribution</span>
          <v-spacer></v-spacer>
          <v-icon @click="close">close</v-icon>
        </v-card-title>
        <v-card-text class="pt-5">
          <v-row>
            <v-col class="pb-0" cols="12" md="2" sm="2" style="min-width:95px;">
              <p class="title-1 form-label font-weight-bold mb-0">Amount: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" sm="6">
              <div class="d-flex flex-row">
                <v-text-field
                  type="number"
                  v-model="editData.amount"
                  :disabled="resetEdit"
                  placeholder=""
                  prefix="$"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
                <v-btn @click="resetEditedMonth" class="warning ml-2" v-if="this.editData.editedCheck">Reset</v-btn>
              </div>
              <!-- <p class="custom-danger" style="margin-top:-22px;" v-if="invalidInvoiceSent">Invoice Sent must be less than Quote Amount!</p> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="2" sm="2" style="min-width:95px">
              <p class="title-1 form-label font-weight-bold mb-0">Recorded:</p>
            </v-col>
            <v-col class="pb-0" cols="12" md="8" sm="8">
              <v-checkbox
                class="mt-0"
                v-model="editData.recordCheck"
                label=""
                color="secondary"
                :true-value="true"
                :false-value="false"
                hide-details
              ></v-checkbox>
              <!-- <p class="custom-danger" style="margin-top:-22px;" v-if="invalidInvoiceSent">Invoice Sent must be less than Quote Amount!</p> -->
            </v-col>
          </v-row>          
          <v-row>
            <v-col style="max-width:95px" class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label font-weight-bold mb-0">Remarks : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-textarea
                v-model="editData.remarks"
                placeholder=""
                outlined
                dense
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Timestamp</th>
                      <th class="text-left">Amount</th>
                      <th class="text-left">Recorded</th>
                      <th class="text-left">Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!editItem.editHistory.length">
                      <td colspan="4">Empty List</td>
                    </tr>
                    <tr v-for="(item, index) in editItem.editHistory" :key="index">
                      <td>{{ formatTime(item.timestamp) }}</td>
                      <td>{{ item.amount | thousandSeprator }}</td>
                      <td>{{ item.recorded ? 'Yes' : 'No' }}</td>
                      <td>{{ item.remarks || '' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="green darken-1" :disabled="!editData.amount && !resetEdit" text @click="saveData">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'DistributionEditModal',
  props: [
    'value',
    'editItem'
  ],
  data() {
    return {
      editData: {
        amount: 0,
        recordCheck: false,
        editedCheck: ''
      },
      resetEdit: false
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.editData.amount = this.editItem.amount
        this.editData.recordCheck = this.editItem.recordCheck
        this.editData.editedCheck = this.editItem.editedCheck
        if (this.editItem.editHistory.length) {
          this.editData.remarks = this.editItem.editHistory[this.editItem.editHistory.length - 1].remarks
        }
        this.resetEdit = false
      }
    }
  },
  computed: {
    ...mapState({
      savedMasterList: state => state.campaign.savedMasterList,
      masterListErr: state => state.campaign.masterListErr
    }),
    currentYear: function() {
      return moment().format('YYYY')
    }
  },
  methods: {
    saveData() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save changes?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let saveData = []
          let quoteData = Object.assign({}, {
            id: this.editItem.id
          })
          // set recorded months
          let recordedMonths = this.editItem.recordedMonths
          if (this.editData.recordCheck && !this.resetEdit) {
            if (!recordedMonths.includes(this.editItem.currentMonth)) {
              recordedMonths.push(this.editItem.currentMonth)
            }
          } else {
            let matchIdx = recordedMonths.findIndex(r => r === this.editItem.currentMonth)
            if (matchIdx !== -1) {
              recordedMonths.splice(matchIdx, 1)
            }
          }
          quoteData.recordedMonths = recordedMonths
          // set edited months
          let editedMonths = this.editItem.editedMonths
          if (!this.resetEdit) {
            if (!editedMonths.includes(this.editItem.currentMonth)) {
              editedMonths.push(this.editItem.editedMonth)
            }
          } else {
            let matchIdx = editedMonths.findIndex(r => r === this.editItem.editedMonth)
            if (matchIdx !== -1) {
              editedMonths.splice(matchIdx, 1)
            }
          }
          quoteData.editedMonths = editedMonths
          // update amt
          if (!this.editItem.monthlyRates[this.editItem.currentMonth]) {
            this.editItem.monthlyRates[this.editItem.currentMonth] = ''
          }
          let mthlyRates = this.editItem.monthlyRates
          mthlyRates[this.editItem.currentMonth] = Number(this.editData.amount)
          quoteData.monthlyRates = mthlyRates
          // push amount edit history
          let editHistory = this.editItem.editHistory
          editHistory.push({
            amount: this.editData.amount,
            recordCheck: this.editData.recordCheck,
            remarks: this.editData.remarks
          })
          quoteData.editHistory = editHistory
          saveData.push(quoteData)
          // Submit request to save campaign data
          await this.$store.dispatch('campaign/saveCampaignMasterLists', {
            data: saveData
          })
          this.isLoading = false;
          if (!this.savedMasterList) {
            this.$swal({
              text: this.masterListErr ? this.masterListErr : 'Error Saving Quote Data.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully saved.',
            type: 'success'
          });
          this.$emit('updated')
          this.close()
        }
      })
    },
    resetEditedMonth() {
      this.resetEdit = true
      this.editData.amount = ''
    },
    close() {
      this.$emit('input');
    },
    formatTime(value) {
      return moment(value).format('DD-MM-YYYY hh:mm:ss')
    }
  }
}
</script>



// WEBPACK FOOTER //
// DistributionEditModal.vue?052083a2